import { Component, OnInit, ViewEncapsulation, HostListener, afterNextRender, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router } from '@angular/router';
import { ChatService } from 'src/app/core/services/chat.service';
import { fromEvent, debounceTime, filter } from 'rxjs';
import { CommonService } from 'src/app/core/services/common.service';
import { HeaderData, HeaderFooterService } from 'src/app/core/services/header-footer.service';
import { StartDatesService } from 'src/app/core/services/start-dates.service';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {

  headerData: HeaderData = {} as HeaderData;
  DefaultHeaderData: HeaderData = {} as HeaderData;
  isContactUsOpen = false;
  isMobile = false;
  isChatInitialized = false;
  isChatLoaded = false;

  constructor(
    private headerService: HeaderFooterService,
    private commonService: CommonService,
    private chatService: ChatService,
    private viewPortScroller: ViewportScroller,
    private startDatesService: StartDatesService,
    private router: Router,
    private destroyRef: DestroyRef
  ) {
    afterNextRender(() => {
      this.setScrollOffset();
      fromEvent(window, 'resize')
        .pipe(debounceTime(200))
        .subscribe(() => this.setScrollOffset());
    })
  }

  ngOnInit(): void {
    this.startDatesService.getDefaultStartDateTermData()
    this.headerService.getDefaultSiteConfiguration();
    // Listen for header configuration changes.
    this.headerService.headerConfiguration.subscribe((headerData: HeaderData | false) => {
      // if value 'false' is passed then use the defaultHeaderData from the service. This used for the override purpose.
      if (headerData) {
        this.headerData = headerData;
      } else {
        this.headerData = this.headerService.defaultHeaderData;
      }
      // Initialize chat widget
      this.initChat();
      if (this.commonService.isPlatformBrowser()) {
        this.setScrollOffset();
      }

    });

    this.chatService.chatWidgetLoaded$.subscribe(data => {
      console.log("chat loaded");
      this.isChatLoaded = data;
    })

    if (this.commonService.isPlatformBrowser()) {
      // Close the Contact Us dropdown on any navigation, including browser back/forward.
      this.router.events
        .pipe(filter(event => event instanceof NavigationStart), takeUntilDestroyed(this.destroyRef))
        .subscribe(() => this.isContactUsOpen = false);
      // Listen for mobile resolution activation
      this.commonService.sm$.subscribe(isMobile => {
        console.log("is mobile ", isMobile);
        this.isMobile = isMobile;
      })
    }

  }

  setScrollOffset() {
    if (window.innerWidth <= 374) {
      this.viewPortScroller.setOffset([0, 137])
    } else if (374 <= window.innerWidth && window.innerWidth <= 639) {
      this.viewPortScroller.setOffset([0, 124])
    } else if (window.innerWidth >= 640) {
      this.viewPortScroller.setOffset([0, 100])
    }
  }

  @HostListener('document:click', ['$event']) onDocumentClick(event: any) {
    if (!event.target.closest('.contact-us')) {
      this.isContactUsOpen = false;
    }
  }

  openContactUs() {
    if (this.isContactUsOpen) {
      this.isContactUsOpen = false
    } else {
      this.isContactUsOpen = true
    }
  }

  triggerChat() {
    this.chatService.chatButtonClick.next(true);
  }

  /**
   * To initialize the genesys chat widget
   */
  initChat() {
    // TIODO - ask business to add a check box to control the enable/disable of chat.
    // check if any value present on chat button field and initialize the chat
    if (!this.isChatInitialized && this.commonService.isPlatformBrowser()) {
      this.chatService.addGenesysChatWidget();
      this.isChatInitialized = true;
    }
  }
}
